import useLazySelector, { isNotCustomer, useLazyLoader } from "common/redux/useLazySelector";
import { loadFcmAccounts } from "./fcmAccounts.actions";
import FcmAccount from "./fcmAccount";
import IsLoaded from "common/isLoaded";

const defaultVal: FcmAccount[] = [];
export default function useFcmAccounts(): FcmAccount[] {
    return useLazySelector(m => m.fcmAccounts, dispatch => loadFcmAccounts()(dispatch), isNotCustomer, defaultVal);
}

export function useFcmAccountsLoader(): IsLoaded<FcmAccount[]> {
    return useLazyLoader(store => store.fcmAccounts, dispatch => loadFcmAccounts()(dispatch), isNotCustomer, defaultVal);
}